(function () {
  app.controller('SitemapCtrl', [
    "$scope", '$timeout',
    function ($scope, $timeout) {
      $scope.data_search = [];
      $scope.key_search = '';
      $scope.find_boxes = [];
      $scope.is_loading = false;


      $scope.init = function () {};

      $scope.getSuggestions = function () {
        $scope.is_loading = true;
        $.ajax({
          beforeSend: function(){
            $(".loading").hide();
            $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
            $(".loading").attr('style', 'z-index: -1 !important');
          },
          url: $scope.search_name_box,
          dataType: "json",
          cache: false,
          type: "POST",
          data: { q: $scope.key_search },
          success: function (rs) {
            $timeout(function () {
              if (rs.succeed) {
                $scope.data_search = rs.data;
                $scope.data_search.forEach(d => {
                  d.hidden = false;
                });
              } else {
                toastr.error("An Unexpected Error Occurred!");
              }
              $scope.is_loading = false;
            });
          },
        })
      }

      $scope.close_menu = function (id) {
        $scope.key_search = '';
        $scope.data_search = [];
        $(`#content-filter-${id}`).removeClass('show');
      }

      $scope.open_menu = function (id) {
        $(`#content-filter-${id}`).addClass('show');
      }

      $scope.click_change = function (id) {
        if ($(`#content-filter-${id}`).hasClass('show')) {
          $scope.close_menu(id);
        } else {
          $('.dropdown-menu.dropdown-menu-right').removeClass('show');
          $scope.key_search = '';
          $scope.data_search = [];
          $scope.is_loading = false;
          $scope.open_menu(id);
        }
      }

      $scope.get_box_name = function (id) {
        let box = $scope.get_box(id)
        return box ? box.box_name : 'Select box';
      }

      $scope.select_box = function(v_id, box) {
        $scope.find_boxes.forEach(b => {
          if (b.id == v_id) {
            if (b.box_id != box.id) b.is_change = true;
            b.box_id = box.id;
            b.box_name = box.name
          }
        })
        $scope.close_menu(v_id);
      }

      $scope.get_box = function(id) {
        return $scope.find_boxes.filter(b => b.id == id)[0] || {}
      }

      $scope.save_box = function(id) {
        let box = $scope.get_box(id);
        
        if(!box) return;

        $.ajax({
          beforeSend: function(){
            // $(".loading").hide();
            // $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
            // $(".loading").attr('style', 'z-index: -1 !important');
          },
          url: $scope.save_box_url.replace('-1', id),
          dataType: "json",
          cache: false,
          type: "POST",
          data: {
            box_id: box.box_id
          },
          afterSend: function(){},
          success: function (rs) {
            $timeout(function () {
              if (rs.succeed) {
                toastr.success('Updated successfully');
                $scope.find_boxes.forEach(b => {
                  if (b.id == id) {
                    b.is_change = false;
                  }
                })
              } else {
                toastr.error("An Unexpected Error Occurred!");
              }
            });
          }
        });
      }

      $scope.update_slug_with_box = function(id) {
        let box = $scope.get_box(id);
        if(!box) return;

        $.ajax({
          beforeSend: function(){
            // $(".loading").hide();
            // $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
            // $(".loading").attr('style', 'z-index: -1 !important');
          },
          url: $scope.update_slug_with_box_url.replace('-1', id),
          dataType: "json",
          cache: false,
          type: "GET",
          afterSend: function(){},
          success: function (rs) {
            $timeout(function () {
              if (rs.succeed) {
                toastr.success(rs.message);
                $scope.find_boxes.forEach(b => {
                  if (b.id == id) {
                    b.is_update_slug = true;
                  }
                });
              } else {
                toastr.error(rs.message || "An Unexpected Error Occurred!");
              }
            });
          }
        });
      }

      $scope.delete_box = function(id) {
        let box = $scope.get_box(id);
        if(!box) return;
        bootbox.confirm(`This will never show up on Sitemap Check for ${$scope.vendor_name} again.`, function(result) {
          if (result) {
            $.ajax({
              beforeSend: function(){
                // $(".loading").hide();
                // $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
                // $(".loading").attr('style', 'z-index: -1 !important');
              },
              url: $scope.delete_record_url.replace('-1', id),
              dataType: "json",
              cache: false, 
              type: "DELETE",
              success: function (rs) {
                $timeout(function () {
                  if (rs.succeed) {
                    toastr.success(rs.message || 'Deleted successfully');
                    $scope.find_boxes.forEach(b => {
                      if (b.id == id) {
                        b.is_update_slug = true;
                        b.is_deleted = true;
                      }
                    });
                  } else {
                    toastr.error(rs.message || "An Unexpected Error Occurred!");
                  }
                });
              }
            });
          }
        });
      }

      $scope.delete_records = function() {
        let values = $("input[type=checkbox].vendor_sitemap_result:not(#select-all):checked")
                      .map(function() {
                        return this.value;
                      })
                      .get();
        if (values.length == 0) {
          toastr.error("Please select at least one result to delete");
          return;
        }

        bootbox.confirm(`Are you sure you want to delete ${values.length} results?`, function(result) {
          if (result) {
            $.ajax({
              beforeSend: function(){
                // $(".loading").hide();
                // $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
                // $(".loading").attr('style', 'z-index: -1 !important');
              },
              url: $scope.delete_records_url,
              dataType: "json",
              cache: false,
              type: "DELETE",
              data: {
                ids: values
              },
              afterSend: function(){},
              success: function (rs) {
                $timeout(function () {
                  if (rs.succeed) {
                    toastr.success('Deleted successfully');
                    Turbolinks.visit(window.location.href);
                  } else {
                    toastr.error("An Unexpected Error Occurred!");
                  }
                });
              }
            });
          }
        });
      }
    }
  ]);

  // The admin-editable keyword list on /sitemap-check (Linear ENG-338). The server
  // (SitemapKeywords) is the only validator and every response carries the current list.
  app.controller('SitemapKeywordsCtrl', [
    "$scope", '$timeout',
    function ($scope, $timeout) {
      $scope.keywords = [];
      $scope.loaded = false;
      $scope.is_saving = false;
      $scope.editing = null;
      // The keyword the Results card is filtered by (?keyword=), or null; set by the view.
      $scope.active_keyword = null;
      // ng-model goes through this holder: ng-repeat and ng-if create child scopes.
      $scope.form = { new_keyword: '', edit_value: '' };

      // Must stay defined: applyData only applies its data once scope.init is truthy.
      $scope.init = function () {};

      function escape_html(s) {
        return $('<div>').text(s).html();
      }

      function send(type, url, data, on_ok) {
        if ($scope.is_saving) return;
        $scope.is_saving = true;
        // No global: false -- these calls are user-initiated (fe.rules.md FE-1).
        $.ajax({
          url: url,
          type: type,
          data: data,
          // Required: a refused (non-admin) call gets the turbolinks gem's redirect back as
          // HTTP 200 text/javascript running Turbolinks.visit. With dataType 'json' jQuery
          // fails to parse it and calls error instead of executing it.
          dataType: 'json',
          cache: false,
          success: function (rs) {
            $timeout(function () {
              $scope.is_saving = false;
              // The server list is authoritative on failure too (another admin may have edited it).
              if (rs && Array.isArray(rs.keywords)) $scope.keywords = rs.keywords;
              if ($scope.editing !== null && $scope.keywords.indexOf($scope.editing) === -1) $scope.editing = null;
              if (rs && rs.succeed) {
                toastr.success(rs.message, '', { escapeHtml: true });
                if (on_ok) on_ok();
              } else {
                toastr.error((rs && rs.message) || "An Unexpected Error Occurred!", '', { escapeHtml: true });
              }
            });
          },
          error: function () {
            $timeout(function () {
              $scope.is_saving = false;
              toastr.error("An Unexpected Error Occurred!");
            });
          }
        });
      }

      $scope.add = function () {
        send('POST', $scope.keywords_url, { keyword: $scope.form.new_keyword }, function () {
          $scope.form.new_keyword = '';
        });
      }

      $scope.start_edit = function (k) {
        $scope.editing = k;
        $scope.form.edit_value = k;
        // ng-if renders the input in this digest; focus it once it exists.
        $timeout(function () {
          $('#sitemap-keywords-card [ng-model="form.edit_value"]').trigger('focus');
        });
      }

      $scope.cancel_edit = function () {
        $scope.editing = null;
      }

      $scope.save_edit = function (k) {
        send('PATCH', $scope.keywords_url, { old_keyword: k, keyword: $scope.form.edit_value }, function () {
          $scope.editing = null;
        });
      }

      // Enter must never reach the page-wide GET form this card sits in: it would submit it
      // and raise the layout's loading overlay.
      $scope.on_new_keydown = function (e) {
        if (e.keyCode === 13) {
          e.preventDefault();
          $scope.add();
        }
      }

      $scope.on_edit_keydown = function (e, k) {
        if (e.keyCode === 13) {
          e.preventDefault();
          $scope.save_edit(k);
        } else if (e.keyCode === 27) {
          e.preventDefault();
          $scope.cancel_edit();
        }
      }

      $scope.remove = function (k) {
        bootbox.confirm('Delete keyword "' + escape_html(k) + '"? Links containing it will no longer be flagged on the next scan.', function (result) {
          if (result) {
            $timeout(function () {
              send('DELETE', $scope.keywords_url, { keyword: k });
            });
          }
        });
      }

      $scope.restore_defaults = function () {
        bootbox.confirm('Replace the current keyword list with the default keywords? Custom keywords will be removed.', function (result) {
          if (result) {
            $timeout(function () {
              send('POST', $scope.reset_keywords_url, {});
            });
          }
        });
      }

      // Filters the Results card by keyword= (an exact match on one of a row's space-joined
      // keywords; q= is the free-text substring search) under type=keyword, for the sitemap
      // currently chosen in the select, the same way update_data_sitemap() reads it.
      $scope.filter_by = function (k) {
        let id = $('#vendor_sitemap_id').val();
        if (!id) {
          toastr.error("Select a retailer sitemap first");
          return;
        }
        Turbolinks.visit($scope.sitemap_check_url + '?' + $.param({ vendor_sitemap_id: id, type: 'keyword', keyword: k }));
      }
    }
  ]);

}).call(this);